import React, {useEffect, useRef, useState} from 'react';
import { Calendar, theme } from 'antd';
import type { CalendarProps } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import {formatDate, formatDateCharDesc, getImagePathWithTheme, isCardEmpty, stringToDate} from "@/utils";
import {isZh} from "@/language";
import {MAP_MONTH_FULL} from "@/Const";
import { t } from 'i18next';
import updateData from 'dayjs/plugin/updateLocale'
import enGB from 'antd/lib/calendar/locale/en_GB'
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import { parse, format } from 'date-fns';

dayjs.extend(updateData);

interface DatePickerPopupProps {
    from?:any,
    defaultDate?: any; // 默认日期参数
    onDateSelect: (date: any,hasClose:any) => void;
    width?:any;
}

const PopupDate: React.FC<DatePickerPopupProps> = ({ defaultDate, onDateSelect,from,width }) => {
    let dayJsDefaultDate = defaultDate && defaultDate !== '-1' && defaultDate !== '0'
        ? dayjs(Number(defaultDate))
        : dayjs()
    // 处理默认日期
    const [selectDate,setSelectDate] = useState<any>(dayJsDefaultDate);
    const inputRef = useRef(null);

    const mIsChangeMonth = useRef(false);
    const mIsDateClicked = useRef(false);

    const noDuedateStyle: React.CSSProperties = {
        fontSize: '14px',
        marginTop:'12px',
        paddingLeft: '10px',
        cursor: 'pointer'
    };

    useEffect(() => {
        dayJsDefaultDate = defaultDate && defaultDate !== '-1' && defaultDate !== '0'
            ? dayjs(Number(defaultDate))
            : dayjs()
        setSelectDate(dayJsDefaultDate);
        setTimeout(()=>{
            if (inputRef.current){
                inputRef.current.value = formatDateCharDesc(defaultDate);
            }
        },100)
    }, [defaultDate]);



    const onSelect = (value: Dayjs) => {
        // const dateString = value.format('YYYY-MM-DD');
        onDateSelect(value.toDate().getTime(),true);
    };

    const getMonthDesc = (value:any)=>{
        if (!value.month){
            value = dayjs(value);
        }
        const selectMonth = value.month() + 1
        if (isZh()){
            return formatDate(value,'yyyy年MM月')
        }
        return t(MAP_MONTH_FULL[`${selectMonth}`]) + '　' + value.year();
    }

    /**
     * 头部
     */
    const calendarHeaderRender = ({value, type, onChange, onTypeChange})=>{

        return <div className={'flex-row-vertical-center'} style={{padding: '6px 10px 12px 10px'}}>
            <span className={'font-family-semi-bold'}
                  style={{color: 'var(--primary-color)'}}>{getMonthDesc(value)}</span>
            <div style={{flexGrow:'1'}}></div>
            <img className={'img-18 cursor-pointer'}
                 src={getImagePathWithTheme('calendar_month_left')}
                 onClick={(event) => {
                     event.stopPropagation();
                     mIsChangeMonth.current = true;
                     mIsDateClicked.current = false;
                     const newValue = value.clone().month(value.month() - 1);
                     setSelectDate(newValue);
                     onChange(newValue);
                 }}/>
            <img className={'img-18 ml-22 cursor-pointer'} src={getImagePathWithTheme('calendar_month_right')}
                 onMouseDown={(event)=>{
                     event.stopPropagation();
                 }}
                 onClick={(event) => {
                     event.stopPropagation();
                     mIsDateClicked.current = false;
                     mIsChangeMonth.current = true;
                     const newValue = value.clone().month(value.month() + 1)
                     setSelectDate(newValue);
                     onChange(newValue)
                 }}/>
        </div>
    }

    const calendarCellRender = (current:any, info) => {
        if (info.type === 'date') {
            const szCurrentFormat = formatDate(current.$d, 'yyyyMMdd');
            const szCurrentDate = formatDate(new Date(), 'yyyyMMdd');
            const isCurDay = szCurrentDate == szCurrentFormat;
            let isSelectedDate = formatDate(selectDate,'yyyyMMdd') == szCurrentFormat;// (/*mIsDateClicked.current || */ formatDate(dayJsDefaultDate.toDate().getTime(),'yyyyMMdd') == szCurrentFormat) && formatDate(selectDate,'yyyyMMdd') == szCurrentFormat;
            const isSelectedMonth = current.month() == selectDate.month()
            const hasJournal = false;

            const getTextColor = ()=>{
                if (isSelectedDate){
                    return 'white';
                }

                if (!isSelectedMonth){
                    return 'var(--color-7d7d7d)';
                }
                if (isCurDay){
                    return 'var(--primary-color)';
                }

                return 'var(--text-color)';
            }

            return (
                <div className={'flex-center'} onClick={(e)=>{
                    e.stopPropagation();
                    onSelect(dayjs(current));
                }}>
                    <div className="ant-picker-cell-inner1"
                         style={{
                             display:'flex',flexDirection:'column',
                             justifyContent:'center',
                             alignItems:'center',
                             width:'28px',height:'28px',
                             border: "none",
                             borderRadius: '20px',
                             textAlign:'center',
                             background:(isSelectedDate)?'var(--primary-color)':'transparent'
                         }}>
                        {/*{current.date()}*/}
                        <span
                            style={{color: getTextColor(),lineHeight:'28px',marginTop:'-3px'}}>{current.date()}</span>
                        <span style={{
                            marginTop: '-6px',
                            width: '4px',
                            height: '4px',
                            borderRadius: '2px',
                            background: (isSelectedDate )?'white':'var(--primary-color)',
                            display: hasJournal ? 'block' : 'none',
                        }}></span>
                    </div>
                </div>

            );
        }
        return info.originNode;
    }



    return (
        <div className={'flex-col'}  onMouseDown={(e)=>{
            e.stopPropagation();
        }}>
            {
                from != 'filter' &&  from != 'batchUpdateProperty' &&
                <input ref={inputRef} autoFocus={true} className={'input-border'} style={{width: '100%'}}
                       onBlur={(e) => {
                           //解析日期....
                           const date = stringToDate(e.currentTarget.value);
                           setSelectDate(dayjs(date));
                           //输入的变为当前日期..
                           inputRef.current.value = formatDateCharDesc(date);
                           //更新，但是不关闭.
                           onDateSelect(date.getTime(), false);
                       }} onFocus={(e) => {
                    inputRef.current?.setSelectionRange(0, inputRef.current.value.length)
                }} onKeyDown={(e) => {
                    if (e.key == KEYS.ENTER) {
                        inputRef.current?.blur();
                    }
                }}/>
            }

            {/* 日历弹窗 */}
            <div style={{width: width || '280px', marginTop: from != 'filter'?'12px':'0px'}}>
                <Calendar
                    locale={enGB}
                    value={(selectDate)}
                    headerRender={calendarHeaderRender}
                    fullCellRender={calendarCellRender}
                    fullscreen={false}
                />
                {
                    from != 'filter' &&
                    <>
                        <div className={'line'} style={{margin: '0 -12px'}}></div>
                        <div onClick={(e) => {
                            e.stopPropagation();
                            onDateSelect(0, true);
                        }} style={noDuedateStyle}>
                            {t("Clear")}
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default PopupDate;